import { render } from "./challengePopup.vue?vue&type=template&id=5321c42c&scoped=true"
import script from "./challengePopup.vue?vue&type=script&lang=js"
export * from "./challengePopup.vue?vue&type=script&lang=js"

import "./challengePopup.vue?vue&type=style&index=0&id=5321c42c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5321c42c"]])

export default __exports__